var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import { initRefs, updateRefs, useCallbacks } from "@/composables/datasetPermissions";
import { getPermissions, getPermissionsUrl, setPermissions } from "./services";
import DatasetPermissionsForm from "@/components/Dataset/DatasetPermissionsForm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryDatasetPermissions',
    props: {
        historyId: null
    },
    setup(__props) {
        const props = __props;
        const loading = ref(true);
        const { managePermissionsOptions, accessPermissionsOptions, managePermissions, accessPermissions, simplePermissions, checked, } = initRefs();
        const inputsUrl = computed(() => {
            return getPermissionsUrl(props.historyId);
        });
        const title = "Change default dataset permissions for history";
        const formConfig = computed(() => {
            return {
                title: title,
                url: inputsUrl.value,
                submitTitle: "Save Permissions",
                redirect: "/histories/list",
            };
        });
        function change(value) {
            return __awaiter(this, void 0, void 0, function* () {
                const managePermissionValue = managePermissions.value[0];
                let access = [];
                if (value) {
                    access = [managePermissionValue];
                }
                const formValue = {
                    DATASET_MANAGE_PERMISSIONS: [managePermissionValue],
                    DATASET_ACCESS: access,
                };
                setPermissions(props.historyId, formValue).then(onSuccess).catch(onError);
            });
        }
        function init() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data } = yield getPermissions(props.historyId);
                updateRefs(data.inputs, managePermissionsOptions, accessPermissionsOptions, managePermissions, accessPermissions);
                loading.value = false;
            });
        }
        const { onSuccess, onError } = useCallbacks(init);
        return { __sfc: true, props, loading, managePermissionsOptions, accessPermissionsOptions, managePermissions, accessPermissions, simplePermissions, checked, inputsUrl, title, formConfig, change, init, onSuccess, onError, DatasetPermissionsForm };
    }
});
